import Select from 'react-select'
import {useTranslation} from 'react-i18next'
import {userLang} from '../../utils'
import styles from './Header.module.scss'
import Logo_1 from 'assets/images/logo.svg'
import Logo_2 from 'assets/images/logo_er.svg'
import EnFlag from 'assets/images/svg/en.svg'
import RuFlag from 'assets/images/svg/ru.svg'
import {Link} from 'react-router-dom';
import { useAuthDispatch, logout } from 'context'
import { useAuthState } from 'context';
import { useHistory, useLocation } from 'react-router-dom';

const options = [
    { label: <div className='options'><img src={EnFlag} height="20px" width="30px" alt='lang' />ENG</div>, value: 'en' },
    { label: <div className='options'><img src={RuFlag} height="20px" width="30px" alt='lang' />RUS</div>, value: 'ru' },
    // { label: <div className='options'><img src={EsFlag} height="20px" width="30px" alt='lang' />ESP</div>, value: 'es' },
    // { label: <div className='options'><img src={FrFlag} height="20px" width="30px" alt='lang' />FRA</div>, value: 'fr' },
]

const Navigation = ()=> {
    const location = useLocation()
    const history = useHistory()    
    const { t } = useTranslation()
    const [n, ph, tw, tr, fr] = t('haderNav', { returnObjects: true })
    const onClick = e => {
        e.preventDefault();
        if (location.pathname !== '/') history.push('/')
        setTimeout(()=> {
            const el = document.querySelector(`${e.target.hash}`)
            el.scrollIntoView({ behavior: 'smooth' })
        }, 300)
    }
    return (
        <nav className={styles.nav}>
            <a href="#prog" onClick={onClick}>{n}</a>
            <a href="#photo" onClick={onClick}>{ph}</a>
            <a href="#material" onClick={onClick}>{tw}</a>
            <a href="#plans" onClick={onClick}>{tr}</a>
            <a href="#address" onClick={onClick}>{fr}</a>
        </nav>
    )
}

export const Header = ({ triggerPhoneModal, isShowMenu }) => {
    const { t, i18n } = useTranslation();
    const { token } = useAuthState()
    const dispatch = useAuthDispatch();
    const history = useHistory()
    const location = useLocation()
    const changeLanguageHandler = (lang) => {
        localStorage.setItem('locale', lang)
        i18n.changeLanguage(lang)
    }

    const getActiveOpt = () => {
        if (userLang().includes('en')) {
            return options[0]
        }
        if (userLang().includes('ru')) {
            return options[1]
        }
        if (userLang().includes('es')) {
            return options[2]
        }
        return options[3]
    }

    const loginHandler = ()=> {
        !token ? triggerPhoneModal() : history.push('/profile')
    }
    const handleLogout = () => {
        if (location.pathname !== '/profile') return history.push('/profile')
        logout(dispatch)
        history.push('/')
    }

    const hasLk = location.pathname !== '/profile' 
    return (
        <header className={styles.header}>
            <div className="container">
                <div className={styles.wrap}>
                    <Link to="/" className={styles.logo_1}>
                        <picture>
                            <img src={Logo_1} alt=""/>
                        </picture>
                    </Link>
                    <div className={styles.center}>
                        <Select
                            isSearchable={false}
                            defaultValue={getActiveOpt()}
                            className="header-select"
                            classNamePrefix="header-select"
                            options={options}
                            onChange={(e) => changeLanguageHandler(e.value)}
                            // menuIsOpen
                        />
                        {isShowMenu && <Navigation/>}

                        { !token ?
                            <button className={['btn', styles.btn].join(' ')} onClick={loginHandler}>
                                {t('login_btn')}
                            </button> :
                            <button className={['btn', styles.btn].join(' ')} onClick={handleLogout}>
                                { hasLk ? <span>{t('login')}</span> :
                                    <>
                                        <span>{t('logout')}</span>
                                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.2 1.8C2.9613 1.8 2.73239 1.89482 2.5636 2.0636C2.39482 2.23239 2.3 2.4613 2.3 2.7V15.3C2.3 15.5387 2.39482 15.7676 2.5636 15.9364C2.73239 16.1052 2.96131 16.2 3.2 16.2H6.8C7.29706 16.2 7.7 16.6029 7.7 17.1C7.7 17.5971 7.29706 18 6.8 18H3.2C2.48391 18 1.79716 17.7155 1.29081 17.2092C0.784463 16.7028 0.5 16.0161 0.5 15.3V2.7C0.5 1.98392 0.784463 1.29716 1.29081 0.790812C1.79716 0.284463 2.48392 0 3.2 0H6.8C7.29706 0 7.7 0.402944 7.7 0.9C7.7 1.39706 7.29706 1.8 6.8 1.8H3.2Z" fill="currentColor"/>
                                            <path d="M12.4636 3.86361C12.8151 3.51214 13.3849 3.51214 13.7364 3.86361L18.2364 8.36361C18.5879 8.71509 18.5879 9.28493 18.2364 9.63641L13.7364 14.1364C13.3849 14.4879 12.8151 14.4879 12.4636 14.1364C12.1121 13.7849 12.1121 13.2151 12.4636 12.8636L15.3272 10H6.35714C5.88376 10 5.5 9.55229 5.5 9C5.5 8.44771 5.88376 8 6.35714 8H15.3272L12.4636 5.13641C12.1121 4.78493 12.1121 4.21509 12.4636 3.86361Z" fill="currentColor"/>
                                        </svg>
                                    </>
                                }
                            </button>
                        }
                    </div>

                    <Link to="/" className={styles.logo_2}>
                        <picture>
                            <img src={Logo_2} alt=""/>
                        </picture>
                    </Link>
                </div>
            </div>
        </header>
    )
}
